import Cookies from 'js-cookie'

import { FB_PIXEL_ID, IS_PRODUCTION } from 'config'

// CookieConsent stores the visitor's choice as cookie_consent=true plus one
// cookie per category; the pixel is a targeting cookie (cookie_3).
export function hasTargetingConsent() {
    return Cookies.get('cookie_consent') === 'true' && Cookies.get('cookie_3') === 'true'
}

function loadPixel() {
    if (window.fbq) return
    // Standard Meta Pixel bootstrap: queue calls until fbevents.js has loaded.
    const fbq = function () {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments)
        else fbq.queue.push(arguments)
    }
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
    window.fbq = fbq
    if (!window._fbq) window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    window.fbq('init', FB_PIXEL_ID)
}

/**
 * Sends a PageView. Does nothing outside production, without an ID, before the
 * visitor has accepted targeting cookies, or outside the browser (prerender).
 */
export function trackPageView() {
    if (typeof window === 'undefined' || !IS_PRODUCTION || !FB_PIXEL_ID || !hasTargetingConsent()) return
    loadPixel()
    window.fbq('track', 'PageView')
}
